<div matDialogTitle>{{title}}</div>

<mat-dialog-content>
  @if (duplicate) {
    @for (department of duplicate.departments; track department) {
      <ul class="modal-text">
        <li>Project id={{duplicate.project_id}} has already been linked to SOS Episodic id={{duplicate.sos_episodic_id}} in department <strong>{{department.name}}</strong>, so it cannot be linked again</li>
      </ul>
    }
  }
  @if (linked) {
    @for (department of linked.departments; track department) {
      <ul class="modal-text">
        <li>Project id={{linked.project_id}} linked to SOS Episodic id={{linked.sos_episodic_id}} in department <strong>{{department.name}}</strong></li>
      </ul>
    }
  }
</mat-dialog-content>
<div class="flex justify-flex-end gap-20">
  <button mat-raised-button [color]="confirmColor" [mat-dialog-close]="true" >{{confirmButton}}</button>
</div>
